export default "__VITE_ASSET__c7fd8f83__"